<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="close">
          <div class="modal-header">
            <md-button @click="close" class="md-simple md-just-icon md-round modal-default-button">
              <md-icon>clear</md-icon>
            </md-button>
            <div>
              <header class="header">
                <span class="title">Orden Y Edición de Fotos</span>
                <navbar :data="data" @change="change"></navbar>
              </header>
            </div>
          </div>

          <div class="modal-body text-center">
            <div class="md-layout">
              <div class="md-layout md-layout-item md-size-25">
                <!-- Sortable Images -->
                <md-content class="md-scrollbar">
                  <draggable
                    v-model="imagesEditing"
                    group="Images"
                    @start="drag=true"
                    @end="drag=false"
                  >
                    <div
                      v-for="element in imagesEditing"
                      :key="element.id"
                      @dblclick="chargeImage(element,true)"
                    >
                      <img v-lazy="element.src" />
                      {{element.id}}
                      <md-divider></md-divider>
                    </div>
                  </draggable>
                </md-content>
              </div>

              <!-- Editor -->
              <div class="md-layout md-layout-item md-size-75">
                <main class="main">
                  <editor v-if="data.loaded" ref="editor" :data="data"></editor>
                  <loader v-else ref="loader" :data="data"></loader>
                </main>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <md-button @click="saved" class="md-info md-round">Listo</md-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import editor from "./components/editor";
import loader from "./components/loader";
import navbar from "./components/navbar";
import { Modal } from "@/components";
import draggable from "vuedraggable";
import { writeImage } from "@/utils";

export default {
  components: {
    editor,
    loader,
    navbar,
    Modal,
    draggable,
  },

  props: {
    images: {
      type: Array,
      require: true,
    },
    imageSelected: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      selectedImage: null,
      imagesEditing: [],
      data: {
        cropped: false,
        cropping: false,
        loaded: false,
        name: "",
        previousUrl: "",
        type: "",
        url: "",
      },
    };
  },

  methods: {
    // Images Transformers
    // create URL required to Editor from File 64 base
    createURLfromFile(src) {
      //Return sucess with new Object
      const objetoImage = {
        cropped: false,
        cropping: false,
        loaded: true,
        url: src,
        type: src.startsWith("data:image/jpeg") ? "image/jpeg" : "image/png",
      };
      return objetoImage;
    },

    createImage(blob) {
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function () {
        var imageDataUrl = reader.result;
      };
    },

    // create File 64 base from link backend resources
    createFilefromLink(link) {
      var blob = null;
      this.$http.get(link, { responseType: "blob" }).then((response) => {
        blob = response.data;
      });
      this.createImage(blob);
    },

    // Modal Triggers
    saved() {
      if (this.data.loaded) {
        this.updateEditedImages()
          .then((images) => {
            this.$emit("saved", images);
            this.close();
          })
          .catch(this.$fireErrorResponse);
      }
    },

    close() {
      this.$emit("close");
    },
    //Doble Click or ShowModal
    chargeImage(image, ban) {
      if (ban && this.data.loaded == true) {
        this.change("remove");
      }
      const pos = this.imagesEditing.indexOf(image);
      if (pos >= 0) {
        this.selectedImage = this.imagesEditing[pos];
        this.data = this.createURLfromFile(this.imagesEditing[pos].src);
      }
    },

    // mutationsEditor
    update(data) {
      // Local update images
      Object.assign(this.data, data);
    },
    change(action) {
      const { editor } = this.$refs;

      switch (action) {
        case "crop":
          editor.crop();
          break;

        case "clear":
          editor.clear();
          break;

        case "restore":
          editor.restore();
          break;

        case "remove":
          editor.reset();
          break;

        case "save":
          editor.save();
          break;

        default:
      }
    },

    updateEditedImages() {
      const { imagesEditing, selectedImage } = this;
      const { previousUrl, url } = this.data;
      const index = imagesEditing.indexOf(selectedImage);
      if (index === -1) {
        return Promise.reject("Not found source image");
      }
      const image = imagesEditing[index];
      const { metadata } = image;
      return writeImage(url, metadata).then((file) => {
        this.imagesEditing.splice(index, 1, {
          ...image,
          src: url,
          file,
        });
        return this.imagesEditing;
      });
    },
  },
  mounted() {
    this.imagesEditing = [...this.images];
    this.chargeImage(this.imageSelected);
  },
};
</script>

<style lang="scss" scoped>
.md-content {
  width: 200px;
  max-width: 200px;
  max-height: 420px;
  overflow: auto;
}

.title[data-v-7eaa6030] {
  color: #000;
  display: block;
  float: left;
  font-size: 3.2rem;
  line-height: 3rem;
}

.modal-container {
  max-width: 1000px;
  max-height: 750px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
}

.modal-header {
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 0px;
}

.app {
  position: relative;
}

.header {
  background-color: #fff;
  height: 3rem;
  overflow: hidden;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
  z-index: 1;
}

@media (min-width: 768px) {
  .header {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.modal-footer {
  padding: 5px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}

.main {
  background-color: #fff;
  bottom: 0;
  top: 3rem;
  left: 0;
  height: 420px;
  width: 750px;
  right: 0;
}

.main-panel .header {
  margin: 0 10px 30px;
  margin-top: 0px;
  margin-right: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}

.main-panel .header .title {
  margin-top: 0px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Outputs/Images/PhotoEditor/index.vue